import {Injectable} from '@angular/core';
import {Observable,Subject} from "rxjs";

/**
 * Service de gestion pour les détails d'une prestation
 *
 * @author Guillaume TRAVOT
 * @date 26/09/2025
 */
@Injectable()
export class PrestationDetailService {
    /** Évènement indiquant la mise à jour des données imbriquées */
    private _nestedDataUpdatedEvent: Subject<void> = new Subject<void>();
    get nestedDataUpdatedEvent$(): Observable<void> { return this._nestedDataUpdatedEvent.asObservable(); }

    /**
     * Emission de l'évènement de mise à jour des données imbriquées
     */
    triggerNestedDataUpdate() {
        //Emission de l'évènement
        this._nestedDataUpdatedEvent.next();
    }
}